import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import './APISettingsTab.css';

const APISettingsTab = () => {
  const { authFetch } = useAuth();
  const [settings, setSettings] = useState({
    client_id: '',
    client_key: '',
    api_endpoint: '',
    description: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await authFetch('/api/api-settings');
        const data = await res.json();
        if (data.status === 'success' && data.data) {
          setSettings(data.data);
        }
      } catch (err) {
        console.error('Failed to fetch API settings', err);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, [authFetch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const res = await authFetch('/api/api-settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings),
      });
      const data = await res.json();
      if (data.status === 'success') {
        toast.success(data.message || 'API Settings saved!');
      } else {
        toast.error(data.message || 'Failed to save');
      }
    } catch (err) {
      console.error(err);
      toast.error('An error occurred while saving.');
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="api-settings-container">
      <h2>Global API Authentication Settings</h2>
      <p>Configure the global Auth client keys used to pull data from upstream servers.</p>
      <form onSubmit={handleSave} className="api-settings-form">
        <div className="form-group">
          <label>API Endpoint (Base URL)</label>
          <input type="text" name="api_endpoint" value={settings.api_endpoint} onChange={handleChange} placeholder="https://api.vendor.com/v1" />
        </div>
        <div className="form-group">
          <label>Client ID</label>
          <input type="text" name="client_id" value={settings.client_id} onChange={handleChange} placeholder="Enter Client ID" />
        </div>
        <div className="form-group">
          <label>Client Key</label>
          <input type="password" name="client_key" value={settings.client_key} onChange={handleChange} placeholder="Enter Client Key / Secret" />
        </div>
        <div className="form-group">
          <label>Description</label>
          <textarea name="description" value={settings.description} onChange={handleChange} placeholder="Optional notes..."></textarea>
        </div>
        <button type="submit" className="save-btn">Save Settings</button>
      </form>
    </div>
  );
};

export default APISettingsTab;
